import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, BadgeType } from '@components/atoms/Badge';
import { OrderState } from '@types';

interface OrderStateBadgeProps {
    state: OrderState;
}

export const OrderStateBadge: FC<OrderStateBadgeProps> = ({ state }) => {
    const { t } = useTranslation();

    const translations = {
        pending: t('order-state.pending'),
        paid: t('order-state.paid'),
        shipped: t('order-state.shipped'),
        delivered: t('order-state.delivered'),
        cancelled: t('order-state.cancelled'),
    };

    switch (state) {
        case OrderState.pending:
            return <Badge label={translations.pending} type={BadgeType.limeGreen} icon="fa-light fa-gear" />;
        case OrderState.paid:
            return <Badge label={translations.paid} type={BadgeType.warning} icon="fa-light fa-coin" />;
        case OrderState.shipped:
            return <Badge label={translations.shipped} type={BadgeType.success} icon="fa-light fa-check" />;
        case OrderState.delivered:
            return <Badge label={translations.delivered} type={BadgeType.info} icon="fa-light fa-hand-holding-box" />;
        case OrderState.cancelled:
            return <Badge label={translations.cancelled} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        default:
            <></>;
    }
};
